import { css } from "styled-components";

import { colorCSS } from "./colors";
import { redundantCssFromKebab } from "./redundant-css";
import { fontSizes } from "./textSize";

// to style UiMarkdown and UiTextBlock consistently - converted to template literal for SSR
export const blockquoteCSS = css`
    blockquote {
        ${redundantCssFromKebab("display", "inline-block")}
        ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
        ${redundantCssFromKebab("line-height", "1.5")}
        ${redundantCssFromKebab("margin-block-end", "1rem")}

        > * {
            ${redundantCssFromKebab("margin-block-start", "1rem")}
            ${redundantCssFromKebab("margin-inline-start", "4.5rem")}
            ${redundantCssFromKebab("margin-inline-end", "1rem")}

            @media (max-width: 576px) {
                ${redundantCssFromKebab("margin-block-start", "0.7rem")}
                ${redundantCssFromKebab("margin-inline-start", "4rem")}
                ${redundantCssFromKebab("margin-block-end", "1rem")}
            }
        }

        &::before {
            ${redundantCssFromKebab("position", "absolute")}
            ${redundantCssFromKebab("color", `${colorCSS("T400")}`)}
            ${redundantCssFromKebab("content", "'\"'")}
            ${redundantCssFromKebab("font-weight", "300")}
            ${redundantCssFromKebab("font-size", "6.5rem")}
            ${redundantCssFromKebab("margin-block-start", "-0.8rem")}

            @media (max-width: 576px) {
                ${redundantCssFromKebab("font-size", "5.5rem")}
                ${redundantCssFromKebab("margin-block-start", "-1rem")}
            }
        }
    }
`;
